export default __webpack_public_path__ + "static/media/sherlock_odin.72297c47.png";